import { ThunkResult } from '../../store'
import billOfLadingApi from '../../apis/billOfLading.api'
import { replaceResult } from './BillsOfLading.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().billsOfLading
    const params = { page, limit, search }
    billOfLadingApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}
